import { colorScale } from 'bam-node-baseball-savant/utils/percentile-colors.ts'
import setTextColorWithBackground from 'bam-node-baseball-savant/utils/set-text-color-with-background.ts'
import React from 'react'
import { COMPARATORS, isComparator } from './types.ts'
import type { Filter, PercentileOption } from './types.ts'

type FilterRowProps = {
    filter: Filter
    options: PercentileOption[]
    onChange: (next: Filter) => void
    onRemove: () => void
}

export default function FilterRow({
    filter,
    options,
    onChange,
    onRemove,
}: FilterRowProps) {
    const { prop, comparator, val } = filter

    const backgroundColor = colorScale(val)
    const textColor = setTextColorWithBackground(backgroundColor)

    return (
        <div
            className="form-group"
            style={{
                display: 'flex',
                paddingBottom: 0,
                marginBottom: '10px',
                gap: '3px',
            }}
        >
            <div className="savant-select" data-title="Percentile">
                <select
                    value={prop}
                    onChange={(e) =>
                        onChange({ ...filter, prop: e.target.value })
                    }
                >
                    {options.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
            </div>
            <div className="savant-select" style={{ width: 'auto' }}>
                <select
                    value={comparator}
                    onChange={(e) => {
                        if (isComparator(e.target.value)) {
                            onChange({ ...filter, comparator: e.target.value })
                        }
                    }}
                    style={{ fontSize: '18px' }}
                >
                    {COMPARATORS.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
            </div>
            <div
                className="savant-select"
                style={{
                    backgroundColor,
                    color: textColor,
                    width: 'auto',
                }}
            >
                <input
                    type="number"
                    min="0"
                    max="100"
                    step="5"
                    value={val}
                    onChange={(e) =>
                        onChange({ ...filter, val: Number(e.target.value) })
                    }
                    style={{
                        backgroundColor,
                        color: textColor,
                        borderRadius: 'var(--savant-select-border-radius)',
                    }}
                />
            </div>
            <button
                type="button"
                onClick={onRemove}
                aria-label="Remove filter"
                className="mono-emoji"
                style={
                    {
                        border: '0.5px solid #ccc',
                        borderRadius: 'var(--savant-select-border-radius)',
                        flexShrink: 0,
                        fontSize: '12px',
                        height: '32px',
                        width: '32px',
                        '--emoji-color': '#d9534f',
                    } as React.CSSProperties
                }
            >
                ❌
            </button>
        </div>
    )
}
